import {get as _get} from 'lodash';

import {refetchQueryByName} from '@utils/apollo';
import {convertToInt} from '@utils/helpers';
import {transformProductsForCoverageDropdown} from '@modules/events/utils/formHelper';
import DefaultForm from '@appComponents/DefaultForm';

export class SetCoverageForm extends DefaultForm {
    prepareDataForSubmit(data) {
        const clipProviders = Object.keys(data.clip_providers ?? {})
            .filter((ectId) => data.clip_providers[ectId])
            .map((ectId) => ({
                clip_provider: convertToInt(data.clip_providers[ectId]),
                event_content_type: convertToInt(ectId),
            }));

        return {
            id: 'UPDATE', //Dummy variable for update
            events: this.props.formParams.optionsVariables.eventsIds,
            products: data.coverage,
            clip_providers: clipProviders,
        };
    }

    componentDidMount() {
        this.setUpdateSuccessCallback(() => {
            refetchQueryByName(this.props.formParams.queryForRefetch);
        });

        const {
            products = [],
            eventContentTypes = [],
            defaultDropdownValue,
        } = _get(this.props, 'formParams.optionsVariables', {});

        this.setField('coverage', {
            options: transformProductsForCoverageDropdown(products),
            defaultValue: products.map(product => convertToInt(product.id)),
        });

        this.setField('clip_providers', {products, eventContentTypes, defaultDropdownValue});
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        if (this.props.formValues.coverage !== prevProps.formValues.coverage) {
            this.setField('clip_providers', {
                hidden: !this.props.formValues.coverage.length,
            });
        }
    }

    renderSaveButton(props = {}) {
        return super.renderSaveButton({...props, ...{content: 'Apply'}});
    }
}

export default SetCoverageForm;
